var map = {
	"./decidim/avatar-multiuser.png": 67871,
	"./decidim/brands/google.svg": 11910,
	"./decidim/cc-badge.png": 95605,
	"./decidim/decidim-logo.svg": 87885,
	"./decidim/default-avatar.svg": 77213,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 71459,
	"./decidim/icons.svg": 49068,
	"./decidim/pattern.png": 52687,
	"./decidim/placeholder.jpg": 69206,
	"./decidim/vendor/leaflet/layers-2x.png": 31525,
	"./decidim/vendor/leaflet/layers.png": 22460,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 73165,
	"./decidim/vendor/leaflet/marker-icon.png": 94228,
	"./decidim/vendor/leaflet/marker-shadow.png": 69163,
	"./decidim/vendor/social-share-button/delicious.svg": 97143,
	"./decidim/vendor/social-share-button/douban.svg": 40207,
	"./decidim/vendor/social-share-button/email.svg": 64088,
	"./decidim/vendor/social-share-button/facebook.svg": 75204,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 24112,
	"./decidim/vendor/social-share-button/google_plus.svg": 70192,
	"./decidim/vendor/social-share-button/hacker_news.svg": 99868,
	"./decidim/vendor/social-share-button/linkedin.svg": 67838,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 96887,
	"./decidim/vendor/social-share-button/pinterest.svg": 46966,
	"./decidim/vendor/social-share-button/qq.svg": 14338,
	"./decidim/vendor/social-share-button/reddit.svg": 21996,
	"./decidim/vendor/social-share-button/telegram.svg": 78945,
	"./decidim/vendor/social-share-button/tumblr.svg": 49278,
	"./decidim/vendor/social-share-button/twitter.svg": 48757,
	"./decidim/vendor/social-share-button/vkontakte.svg": 91015,
	"./decidim/vendor/social-share-button/wechat.svg": 15506,
	"./decidim/vendor/social-share-button/weibo.svg": 42380,
	"./decidim/vendor/social-share-button/whatsapp.svg": 30130,
	"./decidim/vendor/social-share-button/x.svg": 6104,
	"./decidim/vendor/social-share-button/xing.svg": 91600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84312;